import { ReactElement } from "react";

import { ClosePanelArrowRightBlueIcon } from "../../assets";
import { SearchWorkflowTasksResponse } from "../../service/query";
import { CursorDataGrid, EmptyFlyoutPanel } from "../../widget";
import { useYourTasksPanel } from "./useYourTasksPanel";

interface YourTasksPanelProps {
  show: boolean;
  onClose: () => void;
  setSelectedPanelTask: (task: SearchWorkflowTasksResponse["results"][0] | undefined) => void;
  setShowWorkflowTaskPanel: (show: boolean) => void;
  refreshTasks: boolean;
  variant?: "default" | "seed";
}

export const YourTasksPanel = ({
  show,
  onClose,
  setSelectedPanelTask,
  setShowWorkflowTaskPanel,
  refreshTasks,
  variant,
}: YourTasksPanelProps): JSX.Element => {
  const { columns, defaultSortingCriteria, dataIsLoading, onChange } = useYourTasksPanel(
    setSelectedPanelTask,
    setShowWorkflowTaskPanel
  );

  const content = (): ReactElement => (
    <div className="YourTasksPanelContent">
      <button className="YourTasksPanelClose" onClick={onClose} type="button">
        Close panel
        <ClosePanelArrowRightBlueIcon />
      </button>
      <h1>Your tasks</h1>
      <div className="YourTasksPanelTable">
        <CursorDataGrid
          columns={columns}
          clientSide={false}
          filterable
          showFilterToggle
          onChange={onChange}
          sortable
          data={[]}
          refresh={refreshTasks}
          dataIsLoading={dataIsLoading}
          defaultSortingCriteria={defaultSortingCriteria}
          noDataMessage="No tasks to display"
          showTotalCount={false}
          variant={variant}
        />
      </div>
    </div>
  );

  return <EmptyFlyoutPanel show={show} onClose={onClose} size="Large" contentChildren={content()} />;
};
